import "@/App.css";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/landing/SmoothScroll";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Ticker } from "@/components/landing/Ticker";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { CaseStudies } from "@/components/landing/CaseStudies";
import { LeadForm } from "@/components/landing/LeadForm";
import { Newsletter } from "@/components/landing/Newsletter";
import { FAQ } from "@/components/landing/FAQ";
import { Footer } from "@/components/landing/Footer";

function App() {
  return (
    <div className="App grain">
      <SmoothScroll>
        <Nav />
        <main>
          <Hero />
          <Ticker />
          <Features />
          <HowItWorks />
          <CaseStudies />
          <LeadForm />
          <Newsletter />
          <FAQ />
        </main>
        <Footer />
      </SmoothScroll>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#F4F4F0",
            border: "2px solid #FF4500",
            borderRadius: "0",
            fontFamily: '"IBM Plex Mono", monospace',
            fontSize: "12px",
          },
        }}
      />
    </div>
  );
}

export default App;
